import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'
import { RouteConfig } from 'vue-router'
import { conversationAIRouteNames } from '../constants/location'
import { knowledgeBaseRouteNames } from '../constants/location'
import { requireAuthAndLocation } from '../auth'

// const AIEmployeePromo = () =>
//   import(
//     /* webpackChunkName: "ai-employee-promo-location" */ '@/apps/aiEmployeePromo/aiEmployeePromoLocation.vue'
//   ).then(m => m.default)

const CopilotPage = () => import('@/pmd/pages/copilot/CopilotPage.vue').then(m => m.default)


export const copilotRoute: RouteConfig[] = [
  {
    path: 'ask-ai',
    name: conversationAIRouteNames.askAi,
    component: CopilotPage,
    beforeEnter: requireAuthAndLocation,
  }
]
